
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRTotals({
  shop,
  totals,
}) {
  return (
     <TableContainer>
    <Table size="small">
      <TableBody>
        <TableRow
          sx={{
            bgcolor: "primary.light",
            "& td": {
              fontWeight: 700,
              borderTop: "2px solid",
              borderColor: "primary.main",
            },
          }}
        >
          <TableCell>
            Total Shop No. {shop}
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.primeLabour}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.primeStores}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.onCostLabour}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.onCostStores}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.proforma}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.profit}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.supStores}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.freight}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.incentive}
            />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
    </TableContainer>
  );
}

